import type { Quantity } from "../../../../../api/useQuantities";
import t from "../../../../../i18n";

export function getQuantityTypeLabel(quantityType: Quantity["type"]) {
  switch (quantityType) {
    case "FORMULA":
      return t("commons.quantities.selectTypeOption.calculated_value");
    case "MEASURE":
      return t("commons.quantities.selectTypeOption.measure");
    default:
      throw new Error(quantityType satisfies never);
  }
}
